exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".agents-oferta[data-v-29cf5072]{max-width:900px;margin:0 auto;font-family:Arial,sans-serif;line-height:1.6;font-size:14px}.text-center[data-v-29cf5072]{text-align:center}.text-right[data-v-29cf5072]{text-align:right}h5[data-v-29cf5072]{margin-top:24px;margin-bottom:8px}a[data-v-29cf5072]{text-decoration:none}.document-body p[data-v-29cf5072]{margin:8px 0}ul[data-v-29cf5072]{margin:8px 0 8px 20px}", ""]);

// exports
